import {aziendaApi} from "@commons/features/azienda/api";
import {aziendaGeneralitaApi} from "@commons/features/azienda/aziendaGeneralita.api";
import {unitaLocaliApi} from "@commons/features/unitaLocali/api";
import {aziendaTabelleApi} from "@commons/features/azienda/tabelle/aziendaTabelle.api";
import {aziendaQualificheApi} from "@commons/features/azienda/tabelle/aziendaQualifiche.api";
import {elementoRMLXTabellaApi} from "@commons/features/azienda/tabelle/aziendaTabelleElementiRML.api";
import {aziendaMappingApi} from "@commons/features/azienda/tabelle/aziendaMapping.api";

export const aziendaReducers = {
    [aziendaApi.reducerPath]: aziendaApi.reducer,
    [aziendaGeneralitaApi.reducerPath]: aziendaGeneralitaApi.reducer,
    [unitaLocaliApi.reducerPath]: unitaLocaliApi.reducer,
    [aziendaTabelleApi.reducerPath]: aziendaTabelleApi.reducer,
    [aziendaQualificheApi.reducerPath]: aziendaQualificheApi.reducer,
    [aziendaMappingApi.reducerPath]: aziendaMappingApi.reducer,
    [elementoRMLXTabellaApi.reducerPath]: elementoRMLXTabellaApi.reducer,
}
export const aziendaMiddlewares = [
    aziendaApi.middleware,
    aziendaGeneralitaApi.middleware,
    unitaLocaliApi.middleware,
    aziendaTabelleApi.middleware,
    aziendaQualificheApi.middleware,
    aziendaMappingApi.middleware,
    elementoRMLXTabellaApi.middleware,
]